import moment from "moment"; //导入文件

export const searchOption1 = (value)=>{
  let that = value
  return {
    span:6,
    submitBtn:false,
    emptyBtn:false,
    column: [
      {
        label: "班次日期",
        prop: "goShiftTime",
        type:'daterange',
        sortable: 'custom',
        searchRange:true,
        search: true,
        valueFormat: 'yyyy-MM-dd',
        width:140,
        overHidden:true,
        hide:true,
        showColumn:false,
        searchOrder:1,
        searchSpan:6,
        overHidden:true,
      },
      {
        label: "出场班次",
        prop: "goShiftType",
        type: "select", // 下拉选择
        search: true,
        hide:true,
        dataType:'string',
        searchMultiple:true,
        searchOrder:2,
        searchSpan:6,
        dicUrl:"/chain/projectinfo/getShiftOfProject",
        dicFormatter: (res) => {
          return res.data.map((item)=>{
            return {
              label:item,
              value:item,
            }
          })
        },
        formatter:(value)=>{
          return value.goShiftTypeName
        },
        width:120,
        overHidden:true,
      },
      {
        label: "项目名称",
        prop: "projectInfoId",
        search: true,
        type: "select",
        searchOrder:2,
        searchSpan:6,
        hide:true,
        // dataType:'string',
        multiple:true,
        props: {
          label: 'projectName',
          value: 'id'
        },
        dicUrl: '/chain/projectinfo/list',
        searchFilterable: true,  //是否可以搜索
        width:160,
        overHidden:true,
      },
      {
        label: "车牌号",
        prop: "goTruckCode",
        search: true,
        searchOrder:3,
        searchSpan:6,
        width:90,
        overHidden:true,
      },
     
      
     
    ],
  };
}

export const searchOption = (value)=>{
  let that = value
  return {
    span:6,
    submitBtn:false,
    emptyBtn:false,
    column: [
      {
        label: "班次日期",
        prop: "goShiftTime",
        type:'daterange',
        sortable: 'custom',
        searchRange:true,
        search: true,
        valueFormat: 'yyyy-MM-dd',
        width:140,
        overHidden:true,
        hide:true,
        showColumn:false,
        searchOrder:1,
        searchSpan:6,
        overHidden:true,
      },
      {
        label: "出场班次",
        prop: "goShiftType",
        type: "select", // 下拉选择
        search: true,
        hide:true,
        dataType:'string',
        searchMultiple:true,
        searchOrder:2,
        searchSpan:6,
        dicUrl:"/chain/projectinfo/getShiftOfProject",
        dicFormatter: (res) => {
          return res.data.map((item)=>{
            return {
              label:item,
              value:item,
            }
          })
        },
        formatter:(value)=>{
          return value.goShiftTypeName
        },
        width:120,
        overHidden:true,
      },
      {
        label: "项目名称",
        prop: "projectInfoId",
        search: true,
        type: "select",
        searchOrder:2,
        searchSpan:6,
        hide:true,
        // dataType:'string',
        multiple:true,
        props: {
          label: 'projectName',
          value: 'id'
        },
        dicUrl: '/chain/projectinfo/list',
        searchFilterable: true,  //是否可以搜索
        width:160,
        overHidden:true,
      },
      {
        label: "车牌号",
        prop: "goTruckCode",
        search: true,
        searchOrder:3,
        searchSpan:6,
        width:90,
        overHidden:true,
      },
      {
        label: "运输类型",
        prop: "tpMode",
        type: "select", // 下拉选择
        search: true,
        searchOrder:4,
        hide:true,
        dataType:'string',
        searchMultiple:true,
        props: {
          label: "itemName",
          value: "itemValue",
        },
        dicUrl: '/chain/systemdictionaryitem/listDictionaryItem?dictionary=tp_mode',
        width:80,
        // overHidden:true,
      },
      {
        label: "运单状态",
        prop: "status",
        type: "select", // 下拉选择
        search: true,
        hide:true,
        searchOrder:4,
        dataType:'string',
        multiple:true,
        span:12,
        value:"2,3,4,11,12,21,22",
        props: {
          label: "itemName",
          value: "itemValue",
        },
        dicUrl:"/chain/systemdictionaryitem/listDictionaryItem?dictionary=waybill_status",
        width:100,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "运单号",
        prop: "no",
        sortable: 'custom',
        search: true,
        searchOrder:4,
        width:160,
        overHidden:true,
      },
      {
        label: "挖机签单员",
        prop: "inStaffName",
        searchOrder:6,
        search: true,
        width:90,
        overHidden:true,
      },
      {
        label: "出场签单员",
        prop: "goStaffName",
        searchOrder:7,
        search: true,
        width:90,
        overHidden:true,
      },
      {
        label: "项目负责人",
        prop: "leadingNames",
        width:82,
        searchOrder:8,
        search: true,
        width:100,
        hide:true,
        overHidden:true,
      },
      {
        label: "司机",
        prop: "fleetName",
        searchOrder:9,
        search: true,
        width:70,
        hide:true,
        overHidden:true,
      },
      {
        label: "车队名称",
        prop: "captainFleetName",
        search: true,
        searchOrder:10,
        width:70,
        hide:true,
        overHidden:true,
      },
      {
        label: "泥尾",
        prop: "garbageId",
        // sortable: true,
        type: "select", // 下拉选择
        search: true,
        hide:true,
        props: {
          label: "names",
          value: "id",
        },
        // hide:true,
        dicUrl: "/chain/garbage/list",
        filterable: true, //是否可以搜索
        width:120,
        overHidden:true,
      },
      {
        label: "出场签单 \n土质",
        prop: "goSoilType",
        search: true,
        dataType:'string',
        searchMultiple:true,
        className:"custom-label",
        hide:true,
        editDisabled:true,
        type: 'select',   // 下拉选择
        props: {
          label: "itemName",
          value: "itemValue",
        },
        search: true,
        dicUrl: '/chain/systemdictionaryitem/listDictionaryItem?dictionary=soil_type',
        searchFilterable: true,  //是否可以搜索
        // overHidden:true,
      },
     
      
      {
        label: "出场备注",
        prop: "goRemark",
        search: true,
        width:156,
        overHidden:true,
      },
      {
        label: "PC后台 \n备注",
        prop: "pcRemark",
        search: true,
        className:"custom-label",
        width:120,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "挖机签单 \n时间",
        prop: "inDatetime",
        className:"custom-label",
        type:'datetimerange',
        sortable: 'custom',
        searchRange:true,
        search: true,
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        width:160,
        overHidden:true,
      },
      {
        label: "是否有 \n泥尾票",
        prop: "isTicket",
        search: true,
        className:"custom-label",
        type:'select',
        dicData: [
          {
            label: "否",
            value: "0",
          },
          {
            label: "是",
            value: "1",
          },
        ],
        width:94,
        hide:true,
        overHidden:true,
      },
      {
        label: "泥尾票土质",
        prop: "goTicketSoilType",
        search: true,
        width:94,
        hide:true,
        overHidden:true,
      },
      {
        label: "单位",
        prop: "weightUnit",
        type: "select", // 下拉选择
        search: true,
        props: {
          label: "itemName",
          value: "itemValue",
        },
        dicUrl: '/chain/systemdictionaryitem/listDictionaryItem?dictionary=weight_unit',
        display:false,
        width:60,
        hide:true,
        overHidden:true,
      },
      {
        label: "入场签单",
        prop: "isEntrance",
        type: 'select',
        search: true,
        width:70,
        hide:true,
        overHidden:true,
        dicData: [
          {
            label: '否',
            value: '0'
          },
          {
            label: '是',
            value: '1'
          },
        ]
      },
      {
        label: "承运人",
        prop: "carrierName",
        search: true,
        width:70,
        hide:true,
        overHidden:true,
      },
      {
        label: "运单结算 \n类型",
        prop: "settleType",
        type: "select",
        className:"custom-label",
        search: true,
        dataType:'string',
        searchMultiple:true,
        props: {
          label: "itemName",
          value: "itemValue",
        },
        dicUrl: '/chain/systemdictionaryitem/listDictionaryItem?dictionary=settle_type',
        width:110,
        hide:true,
        overHidden:true,
      },
      {
        label: "入场签单 \n车牌",
        prop: "entranceTruckCode",
        search: true,
        width:110,
        className:"custom-label",
        hide:true,
        overHidden:true,
      },
      {
        label: "入场签单人",
        prop: "entranceStaffName",
        search: true,
        width:86,
        hide:true,
        overHidden:true,
      },
      {
        label: "出口签单 \n车型",
        prop: "goVehicleType",
        className:"custom-label",
        search: true,
        type:"select",
        props: {
          label: "itemName",
          value: "itemValue",
        },
        dicUrl: `/chain/systemdictionaryitem/listDictionaryItem?dictionary=go_vehicle_type`,
        width:120,
        hide:true,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "车辆所有人",
        prop: "truckOwnerName",
        search: true,
        width:84,
        hide:true,
        overHidden:true,
      },
      {
        label: "出场签单 \n时间",
        prop: "goTime",
        type:'datetimerange',
        className:"custom-label",
        // sortable: 'custom',
        searchRange:true,
        search: true,
        // formatter: (val) => {
        //   return val.goDatetime && moment(val.goDatetime).format("HH:mm:ss");
        // },
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        width:118,
        hide:true,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "完成日期",
        prop: "completeDate",
        display:false,
        width:94,
        hide:true,
        overHidden:true,
        sortable: 'custom',
        // formatter: (val) => {
        //   return val.completeDatetime && moment(val.completeDatetime).format("YYYY-MM-DD");
        // },
      },
      {
        label: "完成时间",
        prop: "completeTime",
        // sortable: 'custom',
        type:'datetimerange',
        searchRange:true,
        search: true,
        // formatter: (val) => {
        //   return val.completeDatetime && moment(val.completeDatetime).format("HH:mm:ss");
        // },
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        width:94,
        hide:true,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "电子结算卡",
        prop: "settleCardNo",
        component:'myCards',
        // searchSpan:24,
        type:"card",
        hide:true,
        search: true,
        width:160,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "泥尾价",
        prop: "isSetGarbagePreparePrice",
        type: "select", // 下拉选择
        search: true,
        hide: true, //列表页字段隐藏
        showColumn:false,
        dicData: [
          {
            label: '未设置',
            value: '0'
          },
          {
            label: '已设置',
            value: '1'
          },

       ],
        width:96,
        overHidden:true,
        sortable: 'custom',
      },
      {
        label: "结算单号",
        prop: "companySettleNo",
        search: true,
        hide:true,
        minWidth:160,
        overHidden:true,
      },
      
     
    ],
  };
}
